import { Pagination, Modal, Button } from "antd";
import { useEffect, useState, useCallback } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { changeLoader } from "../../../../redux/reducers/loader";
import { formatDateFunction, exportCSV, exportPDf } from "../../../../utils/helper/utils";
import { DownloadOutlined } from "@ant-design/icons";
import { getEventLabel } from "../../../../utils/helper/constants";
import LatestLocationMap from "../../../../Modal/LatestLocationMap";
const DriverReport = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [isLatestLocationMapModalOpen, setIsLatestLocationMapModalOpen] = useState(false);
  const [latestLocationCoordinates, setLatestLocationCoordinates] = useState({});

  const getDriverReports = useCallback(async () => {
    dispatch(changeLoader(true));

    try {
      const params = {
        ...inputData,
        page: paginationModel.page,
        limit: paginationModel.limit,
      };

      const response = await globalRequest(
        Apis.MANAGE_REPORT.GET_DRIVER_REPORT,
        "get",
        {},
        { params },
        true
      );

      if (response?.status === 200) {
        const apiData = response?.data?.data;

        const formattedData =
          apiData?.data?.map((item) => ({
            date: item?.eventsDate,
            driverName: item?.driverDetails?.user?.firstName + " " + item?.driverDetails?.user?.lastName || "N/A",
            fullData: item,
          })) || [];

        setList(formattedData);
        setTotalRows(apiData?.paginator?.itemCount || 0);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }

    dispatch(changeLoader(false));
  }, [dispatch, inputData, paginationModel]);

    const handleExport = async (value, driverId) => {
    dispatch(changeLoader(true));
    try {
        const params = { 
        ...inputData, 
        type: "export",
        driverId: driverId 
        };

        const res = await globalRequest(
        `${Apis.MANAGE_REPORT.GET_DRIVER_REPORT}`,
        "GET",
        {},
        { params },
        true
        );

        if (res?.data?.status === "SUCCESS") {
        const rows = res.data.data.data || [];

        const formatted = [];

        rows.forEach((item) => {
            if (item?.events && item.events.length > 0) {
            item.events.forEach((event, index) => {
                const row = {
                "Date": formatDateFunction(item.eventsDate, "dd/mm/yyyy", true) || "-",
                "Event Type": String(getEventLabel(event.type) || "-"),
                "Time": event.timeStamp ? formatDateFunction(event.timeStamp, "yyyy-mm-dd", true, "at") : "-",
                "Order Number": String(event.orderNumber || "-"),
                "Distance from Previous (km)": event.distanceFromPrevEvent ? String(Number(event.distanceFromPrevEvent).toFixed(2)) : "0.00",
                "Driver Latitude": String(event.driverLatitude || "-"),
                "Driver Longitude": String(event.driverLongitude || "-"),
                "Customer Latitude": String(event.customerLat || "-"),
                "Customer Longitude": String(event.customerLong || "-"),
                "Branch Name": String(event.branchName || "-"),
                "Branch Latitude": String(event.branchLat || "-"),
                "Branch Longitude": String(event.branchLong || "-"),
                };
                formatted.push(row);
            });
            } else {
            // Add a row even if no events
            formatted.push({
                "Date": formatDateFunction(item.eventsDate, "dd/mm/yyyy", true) || "-",
                "Driver Name": `${item?.driverDetails?.user?.firstName || ""} ${item?.driverDetails?.user?.lastName || ""}`.trim() || "-",
                "Driver ID": String(item?.driverId || "-"),
                "Event Number": "-",
                "Event Type": "-",
                "Time": "-",
                "Order Number": "-",
                "Distance from Previous (km)": "-",
                "Driver Latitude": "-",
                "Driver Longitude": "-",
                "Customer Latitude": "-",
                "Customer Longitude": "-",
                "Branch Name": "-",
                "Branch Latitude": "-",
                "Branch Longitude": "-",
            });
            }
        });

        const fileName = `driver-report-${driverId}-${Date.now()}`;

        if (value === "csv") {
            exportCSV(formatted, `${fileName}.csv`);
        } else {
            // For PDF, convert to array format
            const headers = Object.keys(formatted[0]);
            const data = formatted.map((row) => Object.values(row));
            exportPDf(headers, data, `${fileName}.pdf`);
        }
        }
    } catch (e) {
        console.error("Export error:", e);
        toast.error(e.message || "Export failed");
    }
    dispatch(changeLoader(false));
    };

  useEffect(() => {
    getDriverReports();
  }, [getDriverReports]);

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      orderBy: column,
      orderType: order,
    }));
  };
  const handleDateClick = async (row) => {
    setModalLoading(true);
    setSelectedRow(row.fullData);
    setIsModalOpen(true);
    setModalLoading(false);
  };
   const handleLatestLocationMapOk = async () => {
    setIsLatestLocationMapModalOpen(false);
  };
  const handleLatestLocationMapCancel = () => {
    setIsLatestLocationMapModalOpen(false);
  };

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="text-gray-700 capitalize text-xs bg-gray-50">
            <tr>
              <th className="px-3 py-3 whitespace-nowrap">
                Date{" "}
                <SortingArrow
                  onSort={(order) => handleSort("eventsDate", order)}
                />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">
                Driver Name
              </th>
              <th className="px-3 py-3 whitespace-nowrap">
                Last event details
              </th>
            </tr>
          </thead>

          <tbody>
            {list.length > 0 ? (
              list.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                  <td className="px-3 py-4 whitespace-nowrap">
                    <span
                      onClick={() => handleDateClick(item)}
                      style={{
                        color: "#37846B",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      {formatDateFunction(
                        item?.date,
                        "yyyy-mm-dd",
                        false,
                        ""
                      )}
                    </span>
                  </td>
                  <td className="px-3 py-4">{item.driverName}</td>
                 <td className="px-3 py-4 whitespace-nowrap">
                    {item?.fullData?.events?.length > 0 ? (
                        (() => {
                        const lastEvent = item.fullData.events[item.fullData.events.length - 1];

                        return (
                            <div>
                            <p className={`text-sm ${getEventLabel(lastEvent.type === "is_offline" ? "text-red-500" : "text-[#37846B]")}`}>
                                {getEventLabel(lastEvent.type)}
                            </p>

                            <p className="text-sm text-gray-500">
                                {new Date(lastEvent.timeStamp).toLocaleTimeString()}
                            </p>

                            <p className="text-xs text-gray-400">
                                {lastEvent.distanceFromPrevEvent
                                ? `${Number(lastEvent.distanceFromPrevEvent).toFixed(2)} km`
                                : "0 km"}
                            </p>
                            <p className="text-[#37846B] cursor-pointer" onClick={() => {
                                setLatestLocationCoordinates({
                                lat: lastEvent?.driverLatitude,
                                lng: lastEvent?.driverLongitude,
                                });
                                setIsLatestLocationMapModalOpen(true);
                            }}> 
                              {lastEvent?.driverLatitude && lastEvent?.driverLongitude ? `${lastEvent.driverLatitude}, ${lastEvent.driverLongitude}` : "No Location Data"}
                            </p>
                            </div>
                        );
                        })()
                    ) : (
                        <span className="text-gray-400">No Events</span>
                    )}
                    </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="text-center py-6">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {list.length > 0 && (
        <div className="text-right mt-4">
          <Pagination
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger
            current={paginationModel.page}
            pageSize={paginationModel.limit}
            onChange={(page) =>
              setPaginationModel((prev) => ({ ...prev, page }))
            }
            onShowSizeChange={(current, size) =>
              setPaginationModel((prev) => ({ ...prev, limit: size }))
            }
          />
        </div>
      )}
      <Modal
        title={
            <span style={{ color: "#37846B", fontWeight: 600 }}>
                Driver Tracking History
            </span>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={750}
        >
        {selectedRow ? (
            <div className="max-h-[500px] overflow-y-auto pr-2">
            <div className="mb-4 p-3 rounded bg-gray-50 border">
                <p style={{ color: "#37846B", fontWeight: 600 }}>
                    {selectedRow?.driverDetails?.user?.firstName + " " + selectedRow?.driverDetails?.user?.lastName || "N/A"}
                </p>
                <p className="text-sm text-gray-500">
                    {formatDateFunction(selectedRow?.eventsDate, "yyyy-mm-dd")}
                </p>
                <div className="flex gap-2">
                    <Button
                        type="primary"
                        size={14}
                        icon={<DownloadOutlined />}
                        className="cursor-pointer"
                        onClick={() => {
                            handleExport("csv", selectedRow?.driverId);
                        }}
                    >
                        Download in CSV
                    </Button>
                    <Button
                        type="primary"
                        size={14}
                        icon={<DownloadOutlined />}
                        className="cursor-pointer"
                        onClick={() => {
                            handleExport("pdf", selectedRow?.driverId);
                        }}
                    >
                        Download in PDF
                    </Button>
                </div>
            </div>
            {selectedRow?.events?.length > 0 ? (
                selectedRow.events.map((event, index) => (
                <div key={index} className="relative pl-6 pb-6">
                    {index !== selectedRow.events.length - 1 && (
                    <div
                        style={{
                        position: "absolute",
                        left: "8px",
                        top: "20px",
                        bottom: "0",
                        width: "2px",
                        backgroundColor: "#E5E7EB",
                        }}
                    />
                    )}
                    <div
                    style={{
                        position: "absolute",
                        left: "0",
                        top: "5px",
                        height: "16px",
                        width: "16px",
                        borderRadius: "50%",
                        backgroundColor: "#37846B",
                    }}
                    />
                    <div className="bg-white border rounded-lg p-4 shadow-sm">

                    <div className="flex justify-between items-center">
                        <p style={{ color: "#37846B", fontWeight: 600 }}>
                        {getEventLabel(event.type)}
                        </p>
                        <p className="text-sm text-gray-500">
                        {formatDateFunction(event.timeStamp, "yyyy-mm-dd", true, "at")}
                        </p>
                    </div>

                    {event.orderNumber && (
                        <p className="text-sm mt-1">
                        <strong>Orders:</strong>{" "}
                        {Array.isArray(event.orderNumber)
                            ? event.orderNumber.join(", ")
                            : event.orderNumber}
                        </p>
                    )}

                    {event.branchName && (
                        <p className="text-sm mt-1">
                        <strong>Branch:</strong> {event.branchName}
                        </p>
                    )}

                    <p className="text-sm mt-1">
                        <strong>Distance from previous event:</strong>{" "}
                        {event.distanceFromPrevEvent
                        ? `${Number(event.distanceFromPrevEvent).toFixed(2)} km`
                        : "0 km"}
                    </p>

                     <p className="text-[#37846B] cursor-pointer" onClick={() => {
                                setLatestLocationCoordinates({
                                lat: event?.driverLatitude,
                                lng: event?.driverLongitude,
                                });
                                setIsLatestLocationMapModalOpen(true);
                        }}> <strong>Location:</strong>{" "}
                            {event?.driverLatitude && event?.driverLongitude ? `${event.driverLatitude}, ${event.driverLongitude}` : "No Location Data"}
                    </p>

                    </div>
                </div>
                ))
                ) : (
                    <div className="text-center py-6 text-gray-500">
                        No tracking events found for this day
                    </div>
                )}
                </div>
            ) : null}
        </Modal>
        <LatestLocationMap
            isOpen={isLatestLocationMapModalOpen}
            onOk={handleLatestLocationMapOk}
            onCancel={handleLatestLocationMapCancel}
            latestLocationCoordinates={latestLocationCoordinates}
        />
    </>
  );
};

export default DriverReport;